import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Introduction</Summary>
        <Details>
          <p>&nbsp;</p>
          <p>
            This Privacy Notice (hereinafter “Notice”) is issued by AS PlusPlus
            Capital on behalf of the PlusPlus Group and it will inform you as to
            how PlusPlus processes your personal data and tell you about your
            privacy rights. The terms used in this Notice are defined in the
            General Data Protection Regulation (hereinafter “GDPR”) and
            applicable law.
          </p>
          <p>&nbsp;</p>
          <p>
            This Notice is addressed to a natural person from whom or regarding
            whom we collect or receive personal data in the course of providing
            its services or otherwise performing its economic activities
            (hereinafter “you” or “data subject”).
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus Group consists of different legal entities and depending on
            circumstances, relevant PlusPlus company may act as the controller
            of your data (hereinafter “we”, “us” or “data controller”). Contact
            information of such data controllers can be found at the end of this
            Notice. The relationship between processing entities within PlusPlus
            Group are detailed in the arrangements between them.
          </p>
          <p>&nbsp;</p>
          <p>
            Your first point of contact for any request or information regarding
            processing of your personal data or this Notice should be to our
            data protection officer, at the following email address:
            privacy[at]pluspluscapital.eu.
          </p>
          <p>&nbsp;</p>
          <p>
            We will post any material changes to this Notice on our website and,
            where appropriate, we will notify you of the change by email.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>What data do we collect about you?</Summary>
        <Details>
          <p>
            We may collect, store, use, transfer and process in other ways
            different kinds of personal data about you, which can be grouped
            together as follows:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>Contact data (address, e-mail address, phone number etc)</li>
            <li>
              Identification data (name, identification code, date and place of
              birth, nationality, identification document details etc)
            </li>
            <li>
              Employment data (current employer and employment history, job
              title etc)
            </li>
            <li>
              Contract and transaction data (details about claims or contracts
              acquired by PlusPlus and data available from the relevant
              documents, bank account number, income details and property
              details, payment history related to the claims or contracts
              acquired by PlusPlus, data about payment defaults, details of
              other persons related to the claim or contracts acquired by
              PlusPlus (e.g. guarantors, co-recipients of credit, security
              providers) etc)
            </li>
            <li>IP address and analytics data</li>
          </ul>
          <p>&nbsp;</p>
          <p>
            An IP address is a unique numerical address assigned to a computer
            as it logs on to the internet. Your IP address is stored into a log
            when using the online chat option available on our website. An IP
            address is used for technical purposes to ensure the functioning and
            security of our website.
          </p>
          <p>&nbsp;</p>
          <p>
            We use Google Analytics to store certain non-personal information
            about how visitors use our website (website usage times, used
            browser and device, read content, what region visitors come from and
            other similar statistics) so that we may make improvements to our
            website. You can find more information about Google Analytics here:
            https://support.google.com/analytics/answer/1012034?hl=en&ref_topic=6157800
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Where is your personal data collected from?</Summary>
        <Details>
          <ul>
            <li>
              Third persons (including publicly available sources) – such as
              sellers of the claims or contracts (being the original creditors)
              acquired by PlusPlus, persons related to the claim or contract
              (guarantors, co-recipients of credit, security providers etc),
              authorities (courts, bailiffs, bankruptcy administrators etc),
              through searches in electronic databases provided by relevant
              third-party service providers (register of payment defaults, land
              register, commercial register etc) and other publicly available
              sources and search engines;
            </li>
            <li>Companies belonging to the PlusPlus Group;</li>
            <li>
              You – some of the personal data may be given by you to us directly
              by phone, email or otherwise when you communicate with us (forms
              you may complete in the self-service system, records of our
              correspondence and different legal proceedings etc)
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>How do we use (process) your personal data?</Summary>
        <Details>
          <p>
            We will process your personal data for specific purposes and in
            compliance with the GDPR and applicable law.
          </p>
          <p>&nbsp;</p>
          <p>
            The common purposes we process your data and respective legal basis
            for doing so are as follows:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              GDPR Art 6 (1) (b) – for the performance of a contract to which
              you are a party or to take steps in order to enter into contract
              or other arrangement, for example the following activities:
              <ul>
                <li>
                  entering your information into the relevant registers to
                  perform background checks and resolve a claim of PlusPlus;
                </li>
                <li>
                  entering your personal data into our information systems;
                </li>
                <li>
                  handling and/or enforcing the claim that PlusPlus has against
                  you or other relevant person (by communicating with you or
                  third persons or performing any other activities, as the case
                  may be, in order to resolve the relevant claim).
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              GDPR Art 6 (1) (c) – processing is necessary to comply with a
              legal or regulatory obligation, for example:
              <ul>
                <li>managing accounting and auditing of PlusPlus.</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              GDPR Art 6 (1) (f) – processing is necessary for our legitimate
              interests (conducting our business) where interests and
              fundamental rights and freedoms of data subject do not override
              such interests, for example:
              <ul>
                <li>
                  managing our internal business reporting and communication;
                </li>
                <li>
                  advising you on ways you can effectively perform your
                  obligations to PlusPlus;
                </li>
                <li>
                  developing our IT systems, webpages and self-service systems.
                </li>
              </ul>
            </li>
            <li>
              GDPR Art 6 (1) (a) – if you have given your consent to processing
              your personal data, the purposes specified when obtaining your
              consent.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Disclosure of your personal data</Summary>
        <Details>
          <p>
            We may share your personal data with third parties that provide
            services to help us with our economic activities or that have to be
            involved in handling and/or enforcement processes of the claim that
            PlusPlus has against you or other relevant person (see the
            categories of processing purposes above).
          </p>
          <p>&nbsp;</p>
          <p>
            We require our third-party service providers to keep your
            information secure and to process this information based on our
            instructions and requirements consistent with this Notice, the GDPR
            and applicable law. These third parties are authorized to use your
            personal data only for specified purposes in line with the services
            provided to us.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Transfers outside the EEA</Summary>
        <Details>
          <p>
            In order to conduct our economic activities, your personal data may
            be transferred to and processed by recipients which are located
            outside the European Economic Area (hereinafter “EEA”). For example,
            the data servers of some of our third-party providers may be located
            outside of the European Economic Area.
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus will take all measures to ensure that transfers outside the
            EEA are adequately protected as required by this Notice, the GDPR
            and applicable law. With respect to transfers to countries not
            providing an adequate level of data protection, we base the transfer
            on appropriate safeguards, such as standard data protection clauses
            adopted by the European Commission or approved certification
            mechanisms together with binding and enforceable commitments of the
            recipient. Where the personal data is transferred to the US, the
            recipient may be part of the EU-U.S. Privacy Shield and thereby
            recognized as providing an adequate level of data protection and
            therefore facilitate the transfer of information from the EU to the
            US. You can obtain more information or a copy of the appropriate or
            suitable safeguards by writing to privacy[at]pluspluscapital.eu.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Retention and security of your personal data</Summary>
        <Details>
          <p>
            We will process your personal data during the performance of a
            contract or other arrangement and then retain your personal data for
            as long as necessary to fulfil the purposes we collected it for,
            including for compliance of any legal, tax or accounting
            requirements applicable to us.
          </p>
          <p>&nbsp;</p>
          <p>
            The personal data related to contracts and/or transactions form part
            of our accounting and economic activities records and will be
            retained for at least 10 years from the end of the recording year.
            The retention period may be longer if processing of your personal
            data is necessary to comply with other applicable laws or processing
            is required to meet other requirements related to our core economic
            activities (for example, to exercise or defend a legal claim). Once
            the retention period has passed, we will either delete your personal
            data or anonymize your personal data.
          </p>
          <p>&nbsp;</p>
          <p>
            We will retain non-personal and statistical information about the
            usage of our websites for 3 years.
          </p>
          <p>&nbsp;</p>
          <p>
            We have implemented generally accepted standards of technology and
            operational security to protect your personal data from loss,
            misuse, alteration or destruction. We require all personnel to keep
            personal data confidential and only authorized personnel have access
            to this data.
          </p>
          <p>&nbsp;</p>
          <p>
            We will take steps to make sure that appropriate security measures
            are taken so that your privacy rights continue to be protected.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Your rights</Summary>
        <Details>
          <p>
            You have various rights in relation to your personal data which we
            process about you:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>Right to request access:</strong> you may ask us to
              confirm what information we process about you at any time. Where
              we are legally required to do so, we may refuse your request. If
              we refuse your request we will tell you the reasons for doing so.
            </li>
            <li>
              <strong>Right to rectification:</strong> you may request that we
              rectify any inaccurate or incomplete personal data that we process
              about you. If we have shared this personal data with third
              parties, we will notify them about the rectification unless this
              is impossible or involves disproportionate effort. Where we are
              legally permitted to do so, we may refuse your request. If we
              refuse your request we will tell you the reasons for doing so.
            </li>
            <li>
              <strong>Right to erasure:</strong> you have the right to request
              that we erase your personal data in certain circumstances. Where
              we are legally permitted to do so, we may refuse your request. If
              we refuse your request we will tell you the reasons for doing so.
            </li>
            <li>
              <strong>Right to restrict processing:</strong> you have the right
              to restrict processing of your personal data in certain
              circumstances. This means that we can only continue to store your
              data and will not be able to carry out any further processing
              activities. Where we are legally permitted to do so, we may refuse
              your request. If we refuse your request we will tell you the
              reasons for doing so.
            </li>
            <li>
              <strong>Right to object:</strong> in certain circumstances you
              have the right to object to us processing your personal data.
              Where we are legally permitted to do so, we may refuse your
              request. If we refuse your request we will tell you the reasons
              for doing so.
            </li>
            <li>
              <strong>Right of data portability:</strong> you have the right to
              transfer your personal data between data controllers, subject to
              possible limitations from applicable law. This means that you are
              able to transfer the data we process about you to another service
              provider or a third party. We will provide you with your data in a
              commonly used machine-readable format so that you can transfer the
              data to another service provider.
            </li>
            <li>
              <strong>
                Right not to be subject to a decision based solely on automated
                processing
              </strong>
              : you have the right not to be subject to a decision based solely
              on automated processing, including profiling, which produces legal
              effects concerning you or similarly affects you. This right is
              subject to limitations from applicable law. Where we are legally
              permitted to do so, we may refuse your request. If we refuse your
              request we will tell you the reasons for doing so.
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            You may exercise your rights in line with the requirements of the
            GDPR and other applicable laws.
          </p>
          <p>&nbsp;</p>
          <p>
            To exercise your rights please contact us via email at
            privacy[at]pluspluscapital.eu. We may need to request certain
            information or documents from you to help us confirm your identity
            upon communicating with you regarding your privacy rights. This is
            necessary to ensure that personal data is not disclosed to any
            person who is not you or entitled to receive your personal data.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Right to lodge a complaint</Summary>
        <Details>
          <p>
            If you think your privacy rights have been breached, you have the
            right to lodge a complaint with an authority of the country of your
            habitual residence. Contact information for these authorities can be
            accessed here:{" "}
            <a href="https://edpb.europa.eu/about-edpb/board/members_en">
              https://edpb.europa.eu/about-edpb/board/members_en
            </a>
            .
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Data controllers</Summary>
        <Details>
          <ul>
            <li>
              <strong>AS PlusPlus Capital</strong>, address Tartu mnt 83,
              Tallinn, 10115 Estonia, phone +372 6224020, email:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OÜ</strong>, address Tartu mnt 83,
              Tallinn, 10115 Estonia, phone +372 6224020, email:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Legal OÜ</strong>, address Tartu mnt 83, Tallinn,
              10115 Estonia, phone +372 6224020, email:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>
                Ārvalsts komersanta PlusPlus Baltic OU filiāle Latvijā
              </strong>
              , address Akmenu iela 14, Riga, LV-1048 Latvia, phone +371
              29401576, email: privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OU Lietuvos filialas</strong>, address
              Gynėjų g. 16, Vilnius, LT-01109 Lithuania, phone +370 67490065,
              email: privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Capital Oy</strong>, address Kasarmikatu 23 A 7,
              Helsinki, 00130 Finland, phone +358 974790202, e-mail
              privacy[at]pluspluscapital.eu.
            </li>
          </ul>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
